/**
 * StatusFilterPills — the shared status-filter pill row used by the
 * procurement / work-order list pages. Each list keeps its own FILTERS list,
 * filtering logic, and per-key counts; this component owns only the pill
 * markup + active styling. Generic over the key type K so each list's union
 * (e.g. 'ALL' | RequisitionStatus) flows through unchanged.
 */
export interface StatusFilterOption<K extends string> {
  key: K;
  label: string;
  count: number;
}

export default function StatusFilterPills<K extends string>({
  options,
  active,
  onChange,
}: {
  options: StatusFilterOption<K>[];
  active: K;
  onChange: (key: K) => void;
}) {
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {options.map((o) => (
        <button
          key={o.key}
          onClick={() => onChange(o.key)}
          className={`px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider border transition-colors ${
            active === o.key
              ? 'bg-primary text-white border-primary'
              : 'bg-surface text-secondary border-outline-variant hover:border-primary'
          }`}
        >
          {o.label} ({o.count})
        </button>
      ))}
    </div>
  );
}
